module.exports = __webpack_public_path__ + "media/Video 13.0e6a3703.mp4";